var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"300px","position":"absolute","top":"50%","left":"50%","transform":"translate(-50%, -50%)"},attrs:{"width":"300vw","height":"300vw","src":_vm.imageSource}})}
var staticRenderFns = []

export { render, staticRenderFns }